import React from "react";
import PropTypes from "prop-types";
import { StyledItem, StyledTextContent } from "./_.styled";
import { PRESENTATION } from "./presentation";

const RegimenField = ({ label, presentation = PRESENTATION.NONE, display }) => {
  if (!label) {
    return null;
  }

  const isLink =
    presentation === PRESENTATION.BOLD_LINK ||
    presentation === PRESENTATION.LINK;

  const isBold =
    presentation === PRESENTATION.BOLD_LINK ||
    presentation === PRESENTATION.BOLD;

  return (
    <StyledItem
      color={null}
      data-islink={isLink}
      fontWeight={isBold ? "bold" : "normal"}
      display={display || "block"}
    >
      <StyledTextContent label={label} />
    </StyledItem>
  );
};

RegimenField.propTypes = {
  label: PropTypes.string,
  presentation: PropTypes.oneOf(Object.values(PRESENTATION)),
  display: PropTypes.string,
};

export default RegimenField;
